/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seasonal_New_TreeInputs */

const en_seasonal_new_tree = /** @type {(inputs: Seasonal_New_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Early Access to Seasonal New Trees`)
};

const ar_seasonal_new_tree = /** @type {(inputs: Seasonal_New_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استمتع بأشجار جديدة في كل موسم`)
};

const de_seasonal_new_tree = /** @type {(inputs: Seasonal_New_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versuchen Sie zuerst Neue Bäume der Saison`)
};

const es_seasonal_new_tree = /** @type {(inputs: Seasonal_New_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prueba los Nuevos árboles de temporada primero`)
};

const fr_seasonal_new_tree = /** @type {(inputs: Seasonal_New_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essayez les Nouveaux arbres saisonniers en premier`)
};

const it_seasonal_new_tree = /** @type {(inputs: Seasonal_New_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prova prima gli Nuovi alberi stagionali`)
};

const ja_seasonal_new_tree = /** @type {(inputs: Seasonal_New_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シーズン限定の新しい木を先行お試し`)
};

const ko_seasonal_new_tree = /** @type {(inputs: Seasonal_New_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`누구보다 먼저 시즌별 신규 나무를 만나세요`)
};

const pt_br_seasonal_new_tree = /** @type {(inputs: Seasonal_New_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experimente as Novas árvores sazonais primeiro`)
};

const ru_seasonal_new_tree = /** @type {(inputs: Seasonal_New_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Попробуйте Новые сезонные деревья первым`)
};

const th_seasonal_new_tree = /** @type {(inputs: Seasonal_New_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลองปลูกต้นไม้ใหม่ประจำฤดูกาลก่อนใคร`)
};

const tr_seasonal_new_tree = /** @type {(inputs: Seasonal_New_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Önce Mevsimsel Yeni Ağaçlarını dene`)
};

const zh_cn_seasonal_new_tree = /** @type {(inputs: Seasonal_New_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`抢先体验每季最新树种`)
};

const zh_tw_seasonal_new_tree = /** @type {(inputs: Seasonal_New_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搶先體驗每季最新樹種`)
};

/**
* | output |
* | --- |
* | "Early Access to Seasonal New Trees" |
*
* @param {Seasonal_New_TreeInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const seasonal_new_tree = /** @type {((inputs?: Seasonal_New_TreeInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seasonal_New_TreeInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seasonal_new_tree(inputs)
	if (locale === "ar") return ar_seasonal_new_tree(inputs)
	if (locale === "de") return de_seasonal_new_tree(inputs)
	if (locale === "es") return es_seasonal_new_tree(inputs)
	if (locale === "fr") return fr_seasonal_new_tree(inputs)
	if (locale === "it") return it_seasonal_new_tree(inputs)
	if (locale === "ja") return ja_seasonal_new_tree(inputs)
	if (locale === "ko") return ko_seasonal_new_tree(inputs)
	if (locale === "pt_br") return pt_br_seasonal_new_tree(inputs)
	if (locale === "ru") return ru_seasonal_new_tree(inputs)
	if (locale === "th") return th_seasonal_new_tree(inputs)
	if (locale === "tr") return tr_seasonal_new_tree(inputs)
	if (locale === "zh_cn") return zh_cn_seasonal_new_tree(inputs)
	return zh_tw_seasonal_new_tree(inputs)
});